/* eslint-disable import/prefer-default-export */
export const moleTableHeaders = [
  {
    text: 'Actions',
    value: 'actions',
    sortable: false,
    fixed: true,
    width: '20px'
  },
  {
    text: 'Active',
    value: 'IgnitionStatus',
    width: '50px',
    sortable: true // fixed: true
  },
  {
    text: 'Unit Bat',
    value: 'InternalBattery',
    width: '40px' // fixed: true
  },

  {
    text: 'Bat',
    value: 'CarBattery',
    width: '50px', // fixed: true
    sortable: true // fixed: true
  },
  {
    text: 'Reg',
    value: 'RegNumber',
    width: '50px', // fixed: true
    sortable: true // fixed: true
  },
  {
    text: 'Update',
    value: 'LastUpdate',
    width: '70px', // fixed: true
    sortable: true // fixed: true
  },
  {
    text: 'Make/Mod',
    value: 'UserVehicleMake',
    width: '70px' // fixed: true
  },
  {
    text: 'Driver',
    value: 'DriverName',
    width: '70px' // fixed: true
  },
  {
    text: 'Veh/Model',
    value: 'UserVehicleModel',
    width: '100%' // fixed: true
  },

  {
    text: 'ID',
    value: 'ID',
    width: '100%' // fixed: true
  },
  {
    text: 'VIN',
    value: 'VIN',
    width: '100%' // fixed: true
  },
  {
    text: 'ChassisNumber',
    value: 'ChassisNumber',
    width: '100%' // fixed: true
  },
  {
    text: 'SpecialFeatures',
    value: 'SpecialFeatures',
    width: '100%' // fixed: true
  },
  {
    text: 'VehicleColour',
    value: 'VehicleColour',
    width: '100%' // fixed: true
  },
  {
    text: 'Active',
    value: 'Active',
    width: '100%' // fixed: true
  },
  {
    text: 'StockNumber',
    value: 'StockNumber',
    width: '100%' // fixed: true
  },
  {
    text: 'UserVehicleColour',
    value: 'UserVehicleColour',
    width: '100%' // fixed: true
  },
  {
    text: 'Colour',
    value: 'Colour',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitID',
    value: 'UnitID',
    width: '100%' // fixed: true
  },
  {
    text: 'Description',
    value: 'Description',
    width: '100%' // fixed: true
  },
  {
    text: 'MSISDN',
    value: 'MSISDN',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitState',
    value: 'UnitState',
    width: '100%' // fixed: true
  },
  {
    text: 'ClientID',
    value: 'ClientID',
    width: '100%' // fixed: true
  },
  {
    text: 'InceptionDate',
    value: 'InceptionDate',
    width: '100%' // fixed: true
  },
  {
    text: 'VehicleMake',
    value: 'VehicleMake',
    width: '100%' // fixed: true
  },
  {
    text: 'VehicleModel',
    value: 'VehicleModel',
    width: '100%' // fixed: true
  },
  {
    text: 'DriverName',
    value: 'DriverName',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitModel',
    value: 'UnitModel',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitTypeName',
    value: 'UnitTypeName',
    width: '100%' // fixed: true
  },
  {
    text: 'Firmware',
    value: 'Firmware',
    width: '100%' // fixed: true
  },
  {
    text: 'DEALER',
    value: 'DEALER',
    width: '100%' // fixed: true
  },
  {
    text: 'ClientName',
    value: 'ClientName',
    width: '100%' // fixed: true
  },
  {
    text: 'CompanyName',
    value: 'CompanyName',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitModel2ID',
    value: 'UnitModel2ID',
    width: '100%' // fixed: true
  },
  {
    text: 'Speed',
    value: 'Speed',
    width: '100%' // fixed: true
  },
  {
    text: 'Latitude',
    value: 'Latitude',
    width: '100%' // fixed: true
  },
  {
    text: 'Longitude',
    value: 'Longitude',
    width: '100%' // fixed: true
  },
  {
    text: 'TenantCode',
    value: 'TenantCode',
    width: '100%' // fixed: true
  },
  {
    text: 'lcase_RegNumber',
    value: 'lcase_RegNumber',
    width: '100%' // fixed: true
  },
  {
    text: 'lcase_CompanyName',
    value: 'lcase_CompanyName',
    width: '100%' // fixed: true
  },
  {
    text: 'lcase_UnitID',
    value: 'lcase_UnitID',
    width: '100%' // fixed: true
  }
]
